export default __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/loader.01c56779.gif";